import PhotoSwipe from 'photoswipe/dist/photoswipe.js';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js';
import * as loadImage from 'blueimp-load-image/js/index.js';

export default {
    name: 'q-file-gallery',
    props: {
        name: {
            type: String,
            default: 'file_upload[]'
        },
        files: {
            type: [Object, Array],
            default: () => {
                return [];
            }
        },
        options: {
            type: Object,
            default: () => {
                return {
                    index: 0,
                    shareEl: false,
                    arrowEl: true,
                    history: false,
                    tapToClose: false,
                    closeOnScroll: false,
                    pinchToClose: false,
                    bgOpacity: 0.9,
                    tapToToggleControls: false
                };
            }
        },
        upload: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: true
        },
        accept: {
            type: String,
            default: ''
        },
        galleryId: {
            type: Number,
            default: 1
        },
        callbackFunction: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: 'camera-plus-outline'
        }
    },
    data() {
        return {
            uploadedFiles: [],
            currentPhotoIndex: 0,
            gallery: null,
            filesToUpload: [],
            galleryFiles: null,
            isMobile: false,
            showOptionsMenu: false,
            deleteIndex: null,
            showDeleteModal: false
        };
    },
    beforeMount() {
        this.galleryFiles = this.files;

        // Separate documents and photos.
        this.galleryFiles.forEach(file => {
            if (/\.(jpe?g|png|gif)$/i.test(file.src)) {
                file.isImage = true;
            }
        });

        if (window.location.pathname.match(/mobile/)) {
            this.isMobile = true;
        }

        if (this.isMobile) {
            this.options.fullscreenEl = false;
            this.options.zoomEl = false;
        }
    },
    mounted() {
        // Initialize PhotoSwipe component and custom functionality.
        this.initPhotoSwipeFromDOM('.gallery');

        if (this.name) {
            window.tempFileUploadName = this.name;
        }
    },
    watch: {
        uploadedFiles(files) {
            // Retieve the data for the photos to load into photos object.
            if (files) {
                if (this.multiple) {
                    for (var i = 0; i < files.length; i++) {
                        this.filesToUpload.push(files[i]);
                    }
                } else {
                    this.filesToUpload = files;
                }

                // Provide global page variable for quorev2 submissions.
                window.tempFilesToUpload = this.filesToUpload;
                // Provide files for parent component.
                this.$emit('input', this.filesToUpload);
                // Retrieve the photo data for displaying the selected files.
                this.retrievePhotoData(files);
            }
        }
    },
    methods: {
        // Closes menu and confirmation modal if open.
        onClickCancel() {
            this.showOptionsMenu = false;
            this.showDeleteModal = false;
        },
        // Closes menu and opens delete confirmation modal.
        onClickDelete() {
            this.showOptionsMenu = false;
            this.showDeleteModal = true;
        },
        // Delete photo from photos list.
        onConfirmDelete() {
            // Close the PhotoSwipe component.
            if (this.gallery) {
                this.gallery.close();
            }

            // Close all modals and menus.
            this.showOptionsMenu = false;
            this.showDeleteModal = false;

            let fileId = this.galleryFiles[this.deleteIndex];

            if (
                typeof fileId.id !== 'undefined' &&
                fileId.id &&
                this.callbackFunction
            ) {
                window[this.callbackFunction](fileId.id);
            }

            // Check to see if the file was uploaded and if so, delete from filesToUpload too.
            let elementToDelete = this.$el.querySelectorAll('.file')[
                this.deleteIndex
            ];

            if (elementToDelete.getAttribute('href').match(/^data:.*/)) {
                let fileName = elementToDelete.getAttribute('data-alt');

                // Get index of file in filesToUpload object.
                this.filesToUpload.forEach((file, index) => {
                    if (file.name === fileName) {
                        // Remove from filesToUpload object.
                        this.filesToUpload.splice(index, 1);
                        window.tempFilesToUpload = this.filesToUpload;
                    }
                });
            }

            // Remove the deleted photo from the photos object in component.
            this.galleryFiles.splice(this.deleteIndex, 1);

            // Reset delete index.
            this.deleteIndex = null;
        },
        initializeImageWidthHeight(index) {
            if (!this.galleryFiles[index].h || !this.galleryFiles[index].w) {
                let imageId = 'gallery-' + this.galleryId + '-index-' + index;
                let imageElement = document.getElementById(imageId);
                this.galleryFiles[index].h = imageElement.naturalHeight;
                this.galleryFiles[index].w = imageElement.naturalWidth;
                this.$forceUpdate();
            }
        },
        retrievePhotoData(files) {
            let arrayBufferToBase64 = buffer => {
                var binary = '';
                var bytes = new Uint8Array(buffer);
                var len = bytes.byteLength;

                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }

                return window.btoa(binary);
            };

            // Loop through all uploaded files.
            for (let i = 0, len = files.length; i < len; i++) {
                // Create a new FileReader object.
                let fileReader = new FileReader();

                // Handle image.
                if (/\.(jpe?g|png|gif)$/i.test(files[i].name)) {
                    fileReader.onload = () => {
                        let base64img =
                            'data:' +
                            files[i].type +
                            ';base64,' +
                            arrayBufferToBase64(fileReader.result);
                        let view = new DataView(fileReader.result);
                        let rotation = 1; // Non-rotated is the default
                        let newImageHeight, newImageWidth, androidVersion;
                        let androidRegex = /android\s([0-9.]*)/;
                        let android = navigator.userAgent
                            .toLowerCase()
                            .match(androidRegex);

                        // Check if Android.
                        if (android) {
                            androidVersion = parseInt(android[1], 10);
                        }

                        // Check the rotation of the image.
                        if (view.getUint16(0, false) === 0xffd8) {
                            const length = view.byteLength;
                            let offset = 2;

                            while (offset < length) {
                                if (view.getUint16(offset + 2, false) <= 8) {
                                    break;
                                }

                                const marker = view.getUint16(offset, false);
                                offset += 2;

                                if (marker === 0xffe1) {
                                    if (
                                        view.getUint32((offset += 2), false) !==
                                        0x45786966
                                    ) {
                                        break;
                                    }

                                    const little =
                                        view.getUint16((offset += 6), false) ===
                                        0x4949;
                                    offset += view.getUint32(
                                        offset + 4,
                                        little
                                    );
                                    const tags = view.getUint16(offset, little);
                                    offset += 2;

                                    for (let i = 0; i < tags; i++) {
                                        if (
                                            view.getUint16(
                                                offset + i * 12,
                                                little
                                            ) === 0x0112
                                        ) {
                                            rotation = view.getUint16(
                                                offset + i * 12 + 8,
                                                little
                                            );
                                        }
                                    }
                                } else if ((marker & 0xff00) !== 0xff00) {
                                    break;
                                } else {
                                    offset += view.getUint16(offset, false);
                                }
                            }
                        }

                        // Create a new Image for getting image data.
                        let newImage = new Image();

                        newImage.onload = () => {
                            // If android 8 and below.
                            if (android && androidVersion <= 8) {
                                loadImage(
                                    newImage.src,
                                    canvas => {
                                        let data = {
                                            src: canvas.toDataURL(),
                                            w: canvas.width,
                                            h: canvas.height,
                                            isImage: true,
                                            alt: files[i].name,
                                            caption: files[i].name
                                        };

                                        // Push data image src to photos array.
                                        if (!this.multiple) {
                                            this.galleryFiles = [];
                                        }

                                        this.galleryFiles.push(data);
                                    },
                                    {
                                        orientation: true
                                    }
                                );

                                // If anything other than Android 8 and below.
                            } else {
                                if (rotation === 6 || rotation === 8) {
                                    newImageHeight = newImage.width;
                                    newImageWidth = newImage.height;
                                } else {
                                    newImageHeight = newImage.height;
                                    newImageWidth = newImage.width;
                                }

                                let data = {
                                    src: newImage.src,
                                    w: newImageWidth,
                                    h: newImageHeight,
                                    isImage: true,
                                    alt: files[i].name,
                                    caption: files[i].name
                                };

                                // Push data image src to photos array.
                                if (!this.multiple) {
                                    this.galleryFiles = [];
                                }

                                this.galleryFiles.push(data);
                            }
                        };

                        newImage.src = base64img;
                    };

                    fileReader.readAsArrayBuffer(files[i]);

                    // Handle other file.
                } else {
                    // Create a new FileReader object.
                    fileReader.onload = e => {
                        let data = {
                            src: e.target.result,
                            alt: files[i].name,
                            caption: files[i].name
                        };

                        if (!this.multiple) {
                            this.galleryFiles = [];
                        }

                        this.galleryFiles.push(data);
                    };

                    // Read the Url from the uploaded file.
                    // This will trigger the onload event for the File Reader.
                    fileReader.readAsDataURL(files[i]);
                }
            }
        },
        initPhotoSwipeFromDOM(gallerySelector) {
            // PhotoSwipe code for initialization and customization.
            // Everything below within this function is for PhotoSwipe.
            // Some customizations have been made by Quore.
            let options = this.options;

            let parseThumbnailElements = el => {
                var thumbElements = el.childNodes,
                    numNodes = thumbElements.length,
                    items = [],
                    childElements,
                    size,
                    item;

                for (let i = 0; i < numNodes; i++) {
                    el = thumbElements[i];

                    // include only element nodes
                    if (el.nodeType !== 1) {
                        continue;
                    }

                    if (el.classList.contains('gallery-image')) {
                        childElements = el.children;
                        size = el.getAttribute('data-size').split('x');

                        // create slide object
                        item = {
                            src: el.getAttribute('href'),
                            w: parseInt(size[0], 10),
                            h: parseInt(size[1], 10),
                            author: el.getAttribute('data-author'),
                            el: el // save link to element for getThumbBoundsFn
                        };

                        if (childElements.length > 0) {
                            if (childElements.length > 1) {
                                item.title = childElements[1].innerHTML; // caption (contents of figure)
                            }
                        }

                        // original image
                        item.o = {
                            src: item.src,
                            w: item.w,
                            h: item.h
                        };

                        items.push(item);
                    }
                }

                return items;
            };

            // Find nearest parent element
            let closest = (el, fn) => {
                return el && (fn(el) ? el : closest(el.parentNode, fn));
            };

            let onThumbnailsClick = e => {
                e = e || window.event;

                let eTarget = e.target || e.srcElement;
                let clickedListItem = closest(eTarget, function(el) {
                    return (
                        el.classList && el.classList.contains('gallery-image')
                    );
                });
                let clickedFileItem = closest(eTarget, function(el) {
                    return (
                        el.classList &&
                        el.classList.contains('gallery-document')
                    );
                });

                if (!clickedListItem && !clickedFileItem) {
                    return;
                }

                // If it's a clickedListItem then prevent default.
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);

                if (
                    eTarget.parentNode.classList.contains('delete-file') ||
                    eTarget.parentNode.parentNode.classList.contains(
                        'delete-file'
                    )
                ) {
                    let index;
                    if (eTarget.parentNode.classList.contains('delete-file')) {
                        index = eTarget.parentNode.getAttribute('data-index');
                    } else {
                        index = eTarget.parentNode.parentNode.getAttribute(
                            'data-index'
                        );
                    }

                    // Set deleteIndex to the index of the clicked delete button.
                    this.deleteIndex = index;
                    this.onClickDelete();
                    return;
                }

                // If a file is clicked, create a link using file data.
                if (clickedFileItem) {
                    let link = document.createElement('a');
                    // Use the data:application string to create the "file".
                    link.href = clickedFileItem.getAttribute('href');
                    // Use the alt (name) of the file to download as same name.
                    link.download = clickedFileItem.getAttribute('data-alt');
                    // Trigger the click to download the file.
                    link.click();

                    // For Firefox it is necessary to delay revoking the ObjectURL.
                    setTimeout(() => {
                        window.URL.revokeObjectURL(link.href);
                    }, 100);

                    return;
                }

                let clickedGallery = clickedListItem.parentNode;

                let childNodes = clickedListItem.parentNode.childNodes,
                    numChildNodes = childNodes.length,
                    imagesIndex = 0,
                    index;

                // Loop through all files in gallery.
                for (let i = 0; i < numChildNodes; i++) {
                    if (childNodes[i].nodeType !== 1) {
                        continue;
                    }

                    // If it's an image, check if image matches and increment index.
                    if (childNodes[i].classList.contains('gallery-image')) {
                        if (childNodes[i] === clickedListItem) {
                            index = imagesIndex;
                            // Sets the deleteIndex to active slide.
                            this.deleteIndex = i - 1;
                            break;
                        }

                        imagesIndex++;
                    }
                }

                if (index >= 0) {
                    this.currentPhotoIndex = index;
                    openPhotoSwipe(index, clickedGallery);
                }

                return false;
            };

            let photoswipeParseHash = () => {
                let hash = window.location.hash.substring(1),
                    params = {};

                if (hash.length < 5) {
                    // pid=1
                    return params;
                }

                let vars = hash.split('&');

                for (let i = 0; i < vars.length; i++) {
                    if (!vars[i]) {
                        continue;
                    }

                    let pair = vars[i].split('=');

                    if (pair.length < 2) {
                        continue;
                    }

                    params[pair[0]] = pair[1];
                }

                if (params.gid) {
                    params.gid = parseInt(params.gid, 10);
                }

                return params;
            };

            let openPhotoSwipe = (
                index,
                galleryElement,
                disableAnimation,
                fromURL
            ) => {
                let pswpElement = this.$el.querySelectorAll('.pswp')[0],
                    items;

                items = parseThumbnailElements(galleryElement);

                // define options (if needed)
                options.galleryUID = galleryElement.getAttribute(
                    'data-pswp-uid'
                );

                options.getThumbBoundsFn = index => {
                    // See Options->getThumbBoundsFn section of docs for more info
                    let thumbnail = items[index].el.children[0],
                        pageYScroll =
                            window.pageYOffset ||
                            document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect();

                    let imageSize = this.$mq === 'mobile' ? 32 : 64,
                        halfSize = imageSize / 2;

                    return {
                        x: rect.left + (rect.width - imageSize) / 2 + halfSize,
                        y:
                            rect.top +
                            pageYScroll +
                            (rect.height - imageSize) / 2 +
                            halfSize,
                        w: 0
                    };
                };

                options.addCaptionHTMLFn = (item, captionEl) => {
                    if (!item.title) {
                        captionEl.children[0].innerText = '';
                        return false;
                    }

                    captionEl.children[0].innerHTML =
                        item.title +
                        (item.author
                            ? '<br/><small>Photo: ' + item.author + '</small>'
                            : '');
                    return true;
                };

                if (fromURL) {
                    if (options.galleryPIDs) {
                        // parse real index when custom PIDs are used
                        // https://photoswipe.com/documentation/faq.html#custom-pid-in-url
                        for (var j = 0; j < items.length; j++) {
                            if (items[j].pid == index) {
                                options.index = j;
                                break;
                            }
                        }
                    } else {
                        options.index = parseInt(index, 10) - 1;
                    }
                } else {
                    options.index = parseInt(index, 10);
                }

                // exit if index not found
                if (isNaN(options.index)) {
                    return;
                }

                if (disableAnimation) {
                    options.showAnimationDuration = 0;
                }

                // Pass data to PhotoSwipe and initialize it
                this.gallery = new PhotoSwipe(
                    pswpElement,
                    PhotoSwipeUI_Default,
                    items,
                    options
                );

                // see: http://photoswipe.com/documentation/responsive-images.html
                let realViewportWidth,
                    useLargeImages = false,
                    firstResize = true,
                    imageSrcWillChange;

                this.gallery.listen('beforeResize', () => {
                    let dpiRatio = window.devicePixelRatio
                        ? window.devicePixelRatio
                        : 1;
                    dpiRatio = Math.min(dpiRatio, 2.5);
                    realViewportWidth = this.gallery.viewportSize.x * dpiRatio;

                    if (
                        realViewportWidth >= 1200 ||
                        (!this.gallery.likelyTouchDevice &&
                            realViewportWidth > 800) ||
                        screen.width > 1200
                    ) {
                        if (!useLargeImages) {
                            useLargeImages = true;
                            imageSrcWillChange = true;
                        }
                    } else {
                        if (useLargeImages) {
                            useLargeImages = false;
                            imageSrcWillChange = true;
                        }
                    }

                    if (imageSrcWillChange && !firstResize) {
                        this.gallery.invalidateCurrItems();
                    }

                    if (firstResize) {
                        firstResize = false;
                    }

                    imageSrcWillChange = false;
                });

                this.gallery.listen('gettingData', (index, item) => {
                    item.src = item.o.src;
                    item.w = item.o.w;
                    item.h = item.o.h;
                });

                this.gallery.listen('destroy', () => {
                    this.showOptionsMenu = false;
                    document.body.classList.remove('photoswipe-open');
                });

                this.gallery.init();
                document.body.classList.add('photoswipe-open');

                this.gallery.listen('afterChange', () => {
                    // Sets the deleteIndex to active slide.
                    let galleryFileElements = this.gallery.currItem.el
                        .parentNode.children;

                    for (var i = 0; i < galleryFileElements.length; i++) {
                        if (galleryFileElements[i] === this.gallery.currItem.el) {
                            this.deleteIndex = i - 1;
                        }
                    }

                    this.currentPhotoIndex = this.gallery.getCurrentIndex();
                });
            };

            // select all gallery elements
            let galleryElements = this.$el.querySelectorAll(gallerySelector);

            for (let i = 0, l = galleryElements.length; i < l; i++) {
                galleryElements[i].setAttribute('data-pswp-uid', i + 1);
                galleryElements[i].onclick = onThumbnailsClick;
            }

            // Parse URL and open gallery if it contains #&pid=3&gid=1
            let hashData = photoswipeParseHash();

            if (hashData.pid && hashData.gid) {
                openPhotoSwipe(
                    hashData.pid,
                    galleryElements[hashData.gid - 1],
                    true,
                    true
                );
            }
        }
    }
};
